"use client"
import { graphql } from "@opensea/graphql"
import { CollectionNativeCurrencyIdentifierFragment } from "@/components/collection/utils"
import { CollectionStatsSubscriptionFragment } from "@/hooks/api/use-collection-stats-subscription"
import { StatsTableRowFragment } from "../StatsTable/StatsTableRow"
import { StatsVolumeFragment } from "../StatsTable/useStatsVolume"

export const TopStatsTableQuery = graphql(
  `
    query TopStatsTableQuery(
      $cursor: String
      $sort: TopCollectionsSort!
      $filter: TopCollectionsFilter
      $category: CategoryIdentifier
      $limit: Int!
    ) {
      topCollections(
        cursor: $cursor
        sort: $sort
        filter: $filter
        category: $category
        limit: $limit
      ) {
        items {
          id
          slug
          __typename
          ...StatsVolume
          ...StatsTableRow
          ...CollectionStatsSubscription
          ...CollectionNativeCurrencyIdentifier
        }
        nextPageCursor
      }
    }
  `,
  [
    StatsVolumeFragment,
    StatsTableRowFragment,
    CollectionStatsSubscriptionFragment,
    CollectionNativeCurrencyIdentifierFragment,
  ],
)
